import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import messages from './messages';
import BaseContainer from '../base-container';

const VerificationSuccessPage = ({ fieldLabel }) => {
  const { formatMessage } = useIntl();
  const emailConfig = getConfig().ACTIVATION_CONFIRM_EMAIL || getConfig().INFO_EMAIL;
  return (
    <BaseContainer>
      <Helmet>
        <title>
          {formatMessage(messages['activate.account.page.verification.success.page.heading'])}
        </title>
      </Helmet>
      <div id="main-content" className="main-content">
        <h3 className="mb-4.5">{formatMessage(messages['activate.account.page.verification.success.title'])}</h3>
        <div className="mw-xs mt-3 mb-2">
          <p className="mb-4 fs-5">
            Thank You!
          </p>
          <p className="mb-2 fs-5">
            {formatMessage(messages['activate.account.page.verification.success.description.one'], { fieldLabel })}
          </p>
          <strong>Note</strong>
          <p className="mb-4 fs-5">The email will come from <strong>{emailConfig}</strong></p>
          <p>
            {formatMessage(messages['activate.account.page.verification.success.description.two'], { fieldLabel })}
          </p>
        </div>
      </div>
    </BaseContainer>
  );
};

VerificationSuccessPage.propTypes = {
  fieldLabel: PropTypes.string,
};

VerificationSuccessPage.defaultProps = {
  fieldLabel: 'username',
};

export default VerificationSuccessPage;
